import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import { ReportingTheme } from 'modules/theme';
class Reporting extends Component {
  render() {
    const { currentUser } = this.props
    return (
      <ReportingTheme currentUser={currentUser}/>
    );
  }
}

Reporting.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {  }
});

export default connect(stateToProps, dispatchToProps)(Reporting);



// WEBPACK FOOTER //
// src/modules/screens/reporting/Reporting/components/Reporting.js